<div class="cs-email-modal">
  <!-- Header -->
  <div class="cs-email-modal__header">
    <div class="cs-email-modal__from-wrapper">
      <button type="button" class="cs-email-modal__from" (click)="toggleFromDropdown($event)">
        <span>Send email from: <strong>{{ selectedFromLabel }}</strong></span>
        <app-svg-icon icon="emailChevronDown" cssClass="cs-email-modal__chevron"
          [class.cs-email-modal__chevron--open]="showFromDropdown"></app-svg-icon>
      </button>

      <div class="cs-email-modal__from-dropdown cs-email-modal__popover"
        [class.cs-email-modal__popover--open]="showFromDropdown" (click)="$event.stopPropagation()">
        <div class="cs-email-modal__from-search">
          <input type="text" [(ngModel)]="fromSearchTerm" (ngModelChange)="filterFromAddresses()"
            placeholder="Search mail or name" />
          <a class="cs-email-modal__cancel-link" (click)="closeFromDropdown()">Cancel</a>
        </div>
        <div class="cs-email-modal__from-list">
          @for (addr of filteredFromAddresses; track addr.id) {
            <div class="cs-email-modal__from-item" [class.cs-email-modal__from-item--selected]="addr.email === selectedFromAddress"
              (click)="selectFromAddress(addr)">
              <div class="cs-email-modal__from-item-label">{{ addr.name }}</div>
              <div class="cs-email-modal__from-item-email">{{ addr.description }}</div>
            </div>
          } @empty {
            <div class="cs-email-modal__from-empty">No matching addresses</div>
          }
        </div>
      </div>
    </div>

    <button type="button" class="cs-email-modal__close-btn" (click)="close()" aria-label="Close">
      <app-svg-icon icon="emailClose"></app-svg-icon>
    </button>
  </div>

  <!-- v4's `.emailbackdrop`/`#emailcontent.overlay` dimming — shown behind whichever popover
       is open (from-address / template), sitting above normal content but below the popovers. -->
  <div class="cs-email-modal__backdrop" [class.cs-email-modal__backdrop--visible]="showFromDropdown || showTemplatePicker || showAttachmentPicker"></div>

  <!-- Template popover — a sibling positioned the same way as the from-address popover (right
       below the header), matching v4 where all popovers share one position regardless of trigger. -->
  <div class="cs-email-modal__template-panel cs-email-modal__popover"
    [class.cs-email-modal__popover--open]="showTemplatePicker" (click)="$event.stopPropagation()">
    <div class="cs-email-modal__from-search">
      <input type="text" [(ngModel)]="templateSearchTerm" (ngModelChange)="filterTemplates()"
        placeholder="Search folders and templates" />
      <a class="cs-email-modal__cancel-link" (click)="closeTemplatePicker()">Cancel</a>
    </div>

    @if (loadingTemplates) {
      <div class="cs-email-modal__template-status">Loading templates…</div>
    } @else if (templateSearchTerm) {
      @if (!filteredTemplateFlatList.length) {
        <div class="cs-email-modal__template-status">No matching templates</div>
      } @else {
        <ul class="cs-email-modal__template-list">
          @for (node of filteredTemplateFlatList; track node.id) {
            <li class="cs-email-modal__template-item" (click)="selectTemplate(node)">
              <app-svg-icon [icon]="node.isFolder === '1' ? 'emailTemplate' : 'emailTemplateFile'"
                cssClass="cs-email-modal__template-item-icon"></app-svg-icon>
              {{ node.templateName }}
            </li>
          }
        </ul>
      }
    } @else if (!templateList.length) {
      <div class="cs-email-modal__template-status">No templates available</div>
    } @else {
      <ul class="cs-email-modal__template-list">
        <ng-container *ngTemplateOutlet="templateNodes; context: { $implicit: templateList }"></ng-container>
      </ul>
    }

    <ng-template #templateNodes let-nodes>
      @for (node of nodes; track node.id) {
        <li class="cs-email-modal__template-item" [class.cs-email-modal__template-item--folder]="node.isFolder === '1'"
          (click)="selectTemplate(node)">
          @if (node.isFolder === '1') {
            <app-svg-icon icon="emailChevronDown" cssClass="cs-email-modal__template-item-chevron"
              [class.cs-email-modal__template-item-chevron--open]="node.isOpen"></app-svg-icon>
          }
          <app-svg-icon [icon]="node.isFolder === '1' ? 'emailTemplate' : 'emailTemplateFile'"
            cssClass="cs-email-modal__template-item-icon"></app-svg-icon>
          {{ node.templateName }}
          @if (node.isFolder === '1' && node.isOpen && node.loading) {
            <span class="cs-email-modal__template-item-loading">Loading…</span>
          }
        </li>
        @if (node.isFolder === '1' && node.isOpen && node.children?.length) {
          <ul class="cs-email-modal__template-sublist">
            <ng-container *ngTemplateOutlet="templateNodes; context: { $implicit: node.children }"></ng-container>
          </ul>
        }
      }
    </ng-template>
  </div>

  <!-- Attachment picker popover — the record's existing server-side files (v4's `.attachment-container`
       popup); no native OS file dialog. Same position/backdrop as the from-address/template popovers. -->
  <div class="cs-email-modal__template-panel cs-email-modal__attachment-panel cs-email-modal__popover"
    [class.cs-email-modal__popover--open]="showAttachmentPicker" (click)="$event.stopPropagation()">
    @if (loadingAttachments) {
      <div class="cs-email-modal__template-status">Loading files…</div>
    } @else if (!pickableAttachments.length) {
      <div class="cs-email-modal__template-status">No files are available</div>
      <div class="cs-email-modal__attachment-footer">
        <span class="cs-email-modal__cancel-link" (click)="showAttachmentPicker = false">Cancel</span>
      </div>
    } @else {
      <div class="cs-email-modal__attachment-header">
        <span>Available files</span>
        <span class="cs-email-modal__attachments-size"
          [class.cs-email-modal__attachments-size--over]="pendingAttachmentSizeMb > 16">
          {{ pendingAttachmentSizeMb.toFixed(1) }} MB / 16 MB
        </span>
      </div>
      <div class="cs-email-modal__from-search">
        <input type="text" [(ngModel)]="attachmentSearchTerm" (ngModelChange)="filterAttachmentPicker()"
          placeholder="Search" />
      </div>
      @if (attachNotFound) {
        <div class="cs-email-modal__template-status">No matching files</div>
      } @else {
        <ul class="cs-email-modal__attachment-list">
          @for (file of filteredPickableAttachments; track file.id) {
            <li class="cs-email-modal__attachment-pick-item" (click)="toggleAttachmentSelection(file)">
              <input type="checkbox" [checked]="file.selected" (click)="$event.stopPropagation()"
                (change)="toggleAttachmentSelection(file)" />
              <span class="cs-email-modal__attachment-name">{{ file.name }}</span>
            </li>
          }
        </ul>
      }
      <div class="cs-email-modal__attachment-footer">
        <span class="cs-email-modal__cancel-link" (click)="cancelAttachmentPicker()">Cancel</span>
        <button type="button" class="cs-email-modal__send-btn"
          [disabled]="!hasSelectedAttachments || pendingAttachmentSizeMb > 16"
          (click)="confirmAttachmentPicker()">
          Attach file and return to email
        </button>
      </div>
    }
  </div>

  <!-- Activity reminder banner (optional, v4 parity) -->
  @if (activityBanner) {
    <div class="cs-email-modal__banner">
      <input type="checkbox" class="cs-email-modal__banner-checkbox" [(ngModel)]="activityBanner.checked"
        id="cs-email-modal-activity-checkbox" />
      <label for="cs-email-modal-activity-checkbox" class="cs-email-modal__banner-label">
        <app-svg-icon icon="emailPhoneSmall" cssClass="cs-email-modal__banner-icon"></app-svg-icon>
        <span>{{ activityBanner.message }}</span>
      </label>
    </div>
  }

  <!-- To -->
  <div class="cs-email-modal__field">
    <div class="cs-email-modal__select-field">
      <app-cs-select [selectConfig]="toSelectConfig" [hideDropdownIcon]="true" [(ngModel)]="toAddresses"></app-cs-select>
    </div>
    <a type="button" class="cs-email-modal__cc-toggle" (click)="showCc = !showCc">
      {{ showCc ? 'Remove CC' : 'Add CC' }}
    </a>
  </div>

  @if (showCc) {
    <div class="cs-email-modal__field">
      <div class="cs-email-modal__select-field">
        <app-cs-select [selectConfig]="ccSelectConfig" [hideDropdownIcon]="true" [(ngModel)]="ccAddresses"></app-cs-select>
      </div>
    </div>
  }

  <!-- Subject -->
  <div class="cs-email-modal__field b-b-none">
    <!-- <span class="cs-email-modal__field-label">Subject</span> -->
      <div class="cs-email-modal__chips">
        <input type="text" class="cs-email-modal__subject-input" [(ngModel)]="subject" placeholder="Subject" />
      </div>
  </div>

  <!-- Body -->
  <div class="cs-email-modal__body">
    <div class="cs-email-modal__editor" [class.cs-email-modal__editor--toolbar-hidden]="!showFormatting">
      <!-- Toolbar is always initialized (Quill can't add/remove it after init) — the "Aa" icon
           just shows/hides it visually via cs-email-modal__editor--toolbar-hidden. -->
      <cs-quill-editor [(ngModel)]="body" [isNeedToolBar]="true" placeholder="Body"></cs-quill-editor>
    </div>

    @if (showAiPanel) {
      <div class="cs-email-modal__ai-panel">
        <app-ai-improve-modal [originalText]="body" [fieldName]="aiFieldName" (onReplace)="onAiReplace($event)"
          (onCancel)="showAiPanel = false"></app-ai-improve-modal>
      </div>
    }
  </div>

  <!-- Attachments -->
  @if (attachments.length) {
    <div class="cs-email-modal__attachments">
      <div class="cs-email-modal__attachments-header">
        <span>Attachments</span>
        <span class="cs-email-modal__attachments-size"
          [class.cs-email-modal__attachments-size--over]="totalAttachmentSizeMb > 16">
          {{ totalAttachmentSizeMb.toFixed(1) }} MB / 16 MB
        </span>
      </div>
      <ul class="cs-email-modal__attachments-list">
        @for (file of attachments; track file.name; let i = $index) {
          <li class="cs-email-modal__attachment-item">
            <span class="cs-email-modal__attachment-name">{{ file.name }}</span>
            @if (file.uploading) {
              <span class="cs-email-modal__attachment-progress">{{ file.progress }}%</span>
            } @else if (file.error) {
              <span class="cs-email-modal__attachment-error">{{ file.error }}</span>
            }
            @if (file.removable !== false) {
              <button type="button" (click)="removeAttachment(i)" aria-label="Remove attachment">&times;</button>
            }
          </li>
        }
      </ul>
    </div>
  }

  <!-- Footer -->
  <div class="cs-email-modal__footer">
    <div class="cs-email-modal__footer-left">
      <button type="button" class="cs-email-modal__icon-btn" title="Insert template"
        [class.cs-email-modal__icon-btn--disabled]="showAiPanel" [attr.aria-disabled]="showAiPanel"
        (click)="openTemplatePicker()">
        <app-svg-icon icon="emailTemplate"></app-svg-icon>
      </button>
      <button type="button" class="cs-email-modal__icon-btn" title="Attach file"
        [class.cs-email-modal__icon-btn--disabled]="showAiPanel" [attr.aria-disabled]="showAiPanel"
        (click)="openAttachmentPicker()">
        <app-svg-icon icon="emailAttachment"></app-svg-icon>
      </button>
      <button type="button" class="cs-email-modal__icon-btn cs-email-modal__icon-btn--ai" title="Improve with AI"
        (click)="toggleAiPanel()">
        <app-svg-icon icon="aiMagic"></app-svg-icon>
      </button>
      <button type="button" class="cs-email-modal__icon-btn" title="Formatting" [class.cs-email-modal__icon-btn--active]="showFormatting"
        (click)="showFormatting = !showFormatting">
        <app-svg-icon icon="emailFontText"></app-svg-icon>
      </button>
    </div>
    <div class="cs-email-modal__footer-right">
      <button type="button" class="cs-email-modal__discard" (click)="discard()">Discard</button>
      <div class="cs-email-modal__send-group">
        <button type="button" class="cs-email-modal__send-btn" [disabled]="!canSend" (click)="send()">Send</button>
        <button type="button" class="cs-email-modal__send-schedule" title="Schedule send" [disabled]="!canSend">
          <app-svg-icon icon="emailClock"></app-svg-icon>
        </button>
      </div>
    </div>
  </div>
</div>
